// admin/src/pages/Dashboard/dashboardApi.js
// Client methods for Identity Overview dashboard aggregation endpoints

import { request } from "../../utils/request";

const DEFAULT_FETCH_CONFIG = {
  cache: "no-store",
  headers: {
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
  },
};

/**
 * Fetch top-level KPIs, sparkline, and actionable attention list
 * @param {string} range '24h' | '7d' | '30d'
 * @param {AbortSignal} [signal]
 * @param {object} [options]
 */
export const fetchOverview = async (range = "7d", signal, options = {}) => {
  return request("dashboard/overview", {
    method: "get",
    query: { range },
    signal,
    cache: options.cache || DEFAULT_FETCH_CONFIG.cache,
    headers: {
      ...DEFAULT_FETCH_CONFIG.headers,
      ...options.headers,
    },
    ...options,
  });
};

/**
 * Fetch sign-in time-series by outcome and protocol, plus top applications
 * @param {string} range '24h' | '7d' | '30d'
 * @param {AbortSignal} [signal]
 * @param {object} [options]
 */
export const fetchSignins = async (range = "7d", signal, options = {}) => {
  return request("dashboard/signins", {
    method: "get",
    query: { range },
    signal,
    cache: options.cache || DEFAULT_FETCH_CONFIG.cache,
    headers: {
      ...DEFAULT_FETCH_CONFIG.headers,
      ...options.headers,
    },
    ...options,
  });
};

/**
 * Fetch MFA method mix, outcome timeline, and latency benchmarks
 * @param {string} range '24h' | '7d' | '30d'
 * @param {AbortSignal} [signal]
 * @param {object} [options]
 */
export const fetchMfa = async (range = "7d", signal, options = {}) => {
  return request("dashboard/mfa", {
    method: "get",
    query: { range },
    signal,
    cache: options.cache || DEFAULT_FETCH_CONFIG.cache,
    headers: {
      ...DEFAULT_FETCH_CONFIG.headers,
      ...options.headers,
    },
    ...options,
  });
};

/**
 * Fetch asset and posture inventory aggregates
 * @param {AbortSignal} [signal]
 * @param {object} [options]
 */
export const fetchInventory = async (signal, options = {}) => {
  return request("dashboard/inventory", {
    method: "get",
    signal,
    cache: options.cache || DEFAULT_FETCH_CONFIG.cache,
    headers: {
      ...DEFAULT_FETCH_CONFIG.headers,
      ...options.headers,
    },
    ...options,
  });
};

/**
 * Fetch recent admin actions, security alerts, and top failed sign-ins
 * @param {number} [limit=10]
 * @param {AbortSignal} [signal]
 * @param {object} [options]
 */
export const fetchActivity = async (limit = 10, signal, options = {}) => {
  return request("dashboard/activity", {
    method: "get",
    query: { limit },
    signal,
    cache: options.cache || DEFAULT_FETCH_CONFIG.cache,
    headers: {
      ...DEFAULT_FETCH_CONFIG.headers,
      ...options.headers,
    },
    ...options,
  });
};
